import { useState } from 'react';
import { createGuide, cancelGuide } from '../services/paquetexpress.service';

export const usePaquetexpress = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const handleCreateGuide = async (deliveryId: string, totalWeight: number, quantityPackages: number) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    
    try {
      const result = await createGuide(deliveryId, totalWeight, quantityPackages);
      
      if(!result.success){
        setError(result.errorMessage);
        return { success: false, errorMessage: result.errorMessage };
      }
      
      setSuccess(true);
      return { success: true, data: result };
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Error desconocido al crear guía';
      setError(errorMessage);
      console.error('Error en usePaquetexpress:', errorMessage);
      return { success: false, errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const handleCancelGuide = async (trackingNumber: string) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    
    try {
      const result = await cancelGuide(trackingNumber);
      
      if(!result.success){
        setError(result.errorMessage);
        return { success: false, errorMessage: result.errorMessage };
      }
      
      setSuccess(true);
      return { success: true, data: result };
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Error desconocido al cancelar guía';
      setError(errorMessage);
      console.error('Error en usePaquetexpress:', errorMessage);
      return { success: false, errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    success,
    createGuide: handleCreateGuide,
    cancelGuide: handleCancelGuide
  };
}; 